import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { isTokenExpired } from '../utils';

const CategoryCardContainer = styled.div`
  display: flex;
  text-decoration: none;
  color: inherit;
  width: 12vw;
  border-radius: 5px;
  padding: 20px 30px;
  text-align: center;
  flex-direction: column;
  position: relative;
  transition: box-shadow 0.3s ease-in-out;
  cursor: pointer;

  &:hover {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }

  /* Tablet responsive */
  @media (max-width: 768px) {
    width: 100%;
    padding: 15px 10px;
    box-sizing: border-box;
  }

  /* Mobile responsive */
  @media (max-width: 480px) {
    width: 100%;
    min-width: 35vw;
    padding: 10px 8px;
    box-sizing: border-box;
  }

  /* Small mobile responsive */
  @media (max-width: 400px) {
    width: 100%;
    padding: 8px 6px;
    box-sizing: border-box;
  }

  /* Touch device fallback */
  @media (hover: none) and (pointer: coarse) {
    &:active {
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    }
  }
`;

const CategoryImage = styled.img`
  width: 12vw;
  height: 12vw;
  object-fit: cover;

  /* Tablet responsive */
  @media (max-width: 768px) {
    width: 120px;
    height: 120px;
  }

  /* Mobile responsive */
  @media (max-width: 480px) {
    width: 100px;
    height: 100px;
  }

  /* Small mobile responsive */
  @media (max-width: 400px) {
    width: 80px;
    height: 80px;
  }
`;

const CategoryName = styled.h3`
  font-size: 0.95rem;
  font-weight: 600;
  margin: 10px 0 5px;
  height: 2.6em;
  line-height: 1.3em;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  /* Tablet responsive */
  @media (max-width: 768px) {
    font-size: 0.9rem;
    height: 2.4em;
    line-height: 1.2em;
  }

  /* Mobile responsive */
  @media (max-width: 480px) {
    font-size: 0.8rem;
    height: 2.2em;
    line-height: 1.1em;
  }
`;

export default function CategoryCard({ data, style }) {
  const navigate = useNavigate();

  const { id, name, image } = data;

  const handleClick = () => {
    const token = localStorage.getItem('token');

    // Check if user is logged in
    if (!token || isTokenExpired(token)) {
      // Redirect to login page if not logged in
      navigate('/login');
    } else {
      // Navigate to category search if logged in
      const categorySlug = name.replace(/\s+/g, '-');
      navigate(`/search?category=${encodeURIComponent(categorySlug)}`);
    }
  };

  return (
    <CategoryCardContainer onClick={handleClick} style={style}>
      <CategoryImage src={image} alt={name} />
      <CategoryName>{name}</CategoryName>
    </CategoryCardContainer>
  );
}
